import { AbstractService } from '@uniqoders/sdk';
import TourDayItem from '@/api/objects/TourDayItem';
import TourDay from '@/api/objects/TourDay';

export default class TemplateDayItemService extends AbstractService {
  /**
   * Retrieves a specific Template Day Item
   * @param agency
   * @param template
   * @param templateDay
   * @param templateDayItem
   * @protected
   */
  public retrieve(
    agency: string,
    template: number,
    templateDay: number,
    templateDayItem: number): Promise<TourDayItem> {
    return this.request({
      method: 'get',
      url: this.buildPath('/{agency}/template/{template}/day/{templateDay}/item/{templateDayItem}',
        {
          agency,
          template,
          templateDay,
          templateDayItem,
        }),
    });
  }

  /**
   * Creates a single Template Day Item
   * @protected
   * @param agency
   * @param template
   * @param tourDay
   * @param data
   */
  public create(
    agency: string,
    template: number,
    tourDay: number,
    data: Record<string, any>): Promise<TourDayItem> {
    return this.request({
      method: 'post',
      url: this.buildPath('/{agency}/template/{template}/day/{tourDay}/item',
        {
          agency,
          template,
          tourDay,
        }),
      data,
    });
  }

  /**
   * Deletes the specified Template Day Item
   * @param agency
   * @param template
   * @param oldTourDay
   * @param tourDayItem
   * @param newTourDay
   * @protected
   */
  public update(
    agency: string,
    template: number,
    oldTourDay: number,
    tourDayItem: number,
    newTourDay: number): Promise<TourDayItem> {
    return this.request({
      method: 'post',
      url: this.buildPath('/{agency}/template/{template}/day/{oldTourDay}/item/{tourDayItem}/move/{newTourDay}', {
        agency,
        template,
        oldTourDay,
        tourDayItem,
        newTourDay,
      }),
    });
  }

  /**
   * Archives the specified Template Day Item
   * @protected
   * @param agency
   * @param template
   * @param tourDay
   * @param tourDayItem
   */
  public delete(
    agency: string,
    template: number,
    tourDay: number,
    tourDayItem: number): Promise<TourDayItem> {
    return this.request({
      method: 'delete',
      url: this.buildPath('/{agency}/template/{template}/day/{tourDay}/item/{tourDayItem}', {
        agency,
        template,
        tourDay,
        tourDayItem,
      }),
    });
  }

  /**
   * Changes the position of the specified Template Day Item
   * @protected
   * @param agency
   * @param template
   * @param tourDay
   * @param tourDayItem
   * @param data
   */
  public movePosition(
    agency: string,
    template: number,
    tourDay: number,
    tourDayItem: number,
    data: Record<string, number>): Promise<TourDay> {
    return this.request({
      method: 'patch',
      url: this.buildPath('/{agency}/template/{template}/day/{tourDay}/item/{tourDayItem}/position', {
        agency,
        template,
        tourDay,
        tourDayItem,
      }),
      data,
    });
  }
}
